<template>
  <div class="flex">
    <!-- <el-input :value="file" disabled></el-input> -->
    <upload type="file" v-bind="$attrs" @success="success">
      <slot></slot>
    </upload>
  </div>
</template>

<script>
  import upload from './index'

  export default {
    name: 'upload-file',
    components: { upload },
    props: {
      value: {
        type: String,
        default: undefined
      },
      limit: {
        type: Number,
        default: 1
      }
    },
    watch: {
      value(value) {
        this.file = value
      }
    },
    data() {
      return {
        file: this.value,
        loading: false
      }
    },
    methods: {
      success(fileUrl) {
        this.file = fileUrl
        this.$emit('input', fileUrl)
        this.$emit('success', fileUrl)
      },
    }
  }
</script>


<style lang="scss" scoped>
  .flex {
    display: inline-flex;
    vertical-align: top;
  }
</style>